export enum TypesOfWork {
  FullTime = 'Full Time',
  PartTime = 'Part Time',
  ProjectBased = 'Project Based',
}

export enum WorkLocationTypes {
  Remote = 'Remote',
  OnSite = 'On Site',
  Hybrid = 'Hybrid',
}

export enum IdealStartDateValues {
  AsSoonAsPossible = 'As soon as possible',
  WithinTheNextMonth = 'Within the next month',
  DownTheLine = 'Down the Line',
  IllDecideLater = "I'll decide later",
}

export enum WorkingDaysValues {
  Standard = 'Standard',
  Weekends = 'Weekends',
  Flexible = 'Flexible',
  Other = 'Other',
}

export const TIMEZONES = [
  'UTC-11 (Samoa Time)',
  'UTC-10 (Hawaii-Aleutian Time)',
  'UTC-9 (Alaska Time)',
  'UTC-8 (Pacific Time)',
  'UTC-7 (Mountain Time)',
  'UTC-6 (Central Time)',
  'UTC-5 (Eastern Time)',
  'UTC-4 (Atlantic Time)',
  'UTC-3:30 (Newfoundland Time)',
  'UTC-3 (Brasília Time)',
  'UTC-2 (Fernando de Noronha)',
  'UTC-1 (Azores Time)',
  'UTC+0 (GMT/WET)',
  'UTC+1 (CET)',
  'UTC+2 (EET/CEST)',
  'UTC+3 (MSK/FET)',
  'UTC+4 (SAMT)',
];

export enum OrganizationSizeTypes {
  StartUp = 'Start Up',
  SMB = 'SMB',
  MidMarket = 'Mid-Market',
  Enterprise = 'Enterprise',
}

export enum SeniorityLevelType {
  ENTRY_LEVEL = 'Entry Level',
  MID_LEVEL = 'Mid Level',
  SENIOR = 'Senior',
}
